import React, { Component } from 'react'
import classNames from 'classnames'

import './Video.css'

class Video extends Component {


    onCanPlayThrough(){
        // console.log('onCanPlayThrough')
    }


    render() {

        const { data, cover } = this.props
        const { file } = data.fields

        const videoClass = classNames({
            video: true,
            cover: cover
        });

        return (

            <div className={videoClass}>
                <video ref={(video) => { this.video = video}} onCanPlayThrough={this.onCanPlayThrough} controls autoPlay loop playsInline muted >
                    <source src={file.url} type="video/mp4" />
                </video>
            </div>


        );
    }
}


export default Video;